export function CandidateYearForBirthDay(): string[] {
  const d = new Date(Date.now());
  const startYear = d.getFullYear();

  const years: string[] = [];
  for (let i = 0; i <= 100; i++) {
    years.push(String(startYear - i));
  }

  return years;
}

export function CandidateMonthForBirthDay(): string[] {
  const months: string[] = [];
  for (let i = 1; i <= 12; i++) {
    months.push(i.toString());
  }

  return months;
}

export function CandidateDayForBirthDay(
  year: number | undefined,
  month: number | undefined
): string[] {
  const days: string[] = [];
  if (year == null || month == null) return days;
  const daysInMonth = new Date(year, month, 0).getDate();
  for (let i = 1; i <= daysInMonth; i++) {
    days.push(i.toString());
  }

  return days;
}
